import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDistanceToNow } from "date-fns";

const ProposalCard = ({ proposal, compact = false, actionButton = null, onClick = null }) => {
  const navigate = useNavigate();

  const statusColors = {
    Active: "bg-emerald-100 text-emerald-700",
    Completed: "bg-blue-100 text-blue-700",
    Archived: "bg-slate-100 text-slate-700",
  };

  const typeColors = {
    RFP: "bg-primary-100 text-primary-700",
    Past_Proposal: "bg-slate-100 text-slate-700",
  };

  const handleCardClick = () => {
    // Use custom onClick if provided, otherwise default to workspace
    if (onClick) {
      onClick();
    } else {
      navigate(`/workspace/${proposal.proposal_id}`);
    }
  };

  const handleActionClick = (e) => {
    e.stopPropagation(); // Prevent parent click
    if (onClick) {
      onClick();
    } else {
      navigate(`/workspace/${proposal.proposal_id}`);
    }
  };

  return (
    <div
      className="bg-white border border-slate-200 rounded-lg p-4 hover:shadow-md hover:border-slate-300 transition-all duration-200 cursor-pointer"
      onClick={handleCardClick}
    >
      {/* Header Section */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-slate-900 truncate">
            {proposal.proposal_name}
          </h3>
          {proposal.customer_name && (
            <p className="text-sm text-slate-600 mt-1">
              {proposal.customer_name}
            </p>
          )}
        </div>
        <div className="flex flex-col items-end space-y-2 ml-3">
          <span
            className={`px-2 py-1 text-xs font-medium rounded ${
              statusColors[proposal.status] || statusColors["Active"]
            }`}
          >
            {proposal.status}
          </span>
          <span
            className={`px-2 py-1 text-xs font-medium rounded ${
              typeColors[proposal.proposal_type] || typeColors["RFP"]
            }`}
          >
            {proposal.proposal_type}
          </span>
        </div>
      </div>

      {/* Metadata Section */}
      <div className="flex items-center justify-between text-xs text-slate-500 mb-3">
        <div className="flex items-center space-x-4">
          {proposal.document_count > 0 && (
            <span className="flex items-center">
              <FontAwesomeIcon icon="file-alt" className="mr-1" />
              {proposal.document_count} docs
            </span>
          )}
          {proposal.due_date && (
            <span className="flex items-center">
              <FontAwesomeIcon icon="calendar" className="mr-1" />
              Due{" "}
              {formatDistanceToNow(new Date(proposal.due_date), {
                addSuffix: true,
              })}
            </span>
          )}
        </div>
        <span>
          {formatDistanceToNow(new Date(proposal.created_at), {
            addSuffix: true,
          })}
        </span>
      </div>

      {/* Action Section */}
      <div className="flex items-center justify-end pt-3 border-t border-slate-100">
        <button
          onClick={handleActionClick}
          className={`px-4 py-2 text-white text-sm rounded-lg transition-colors flex items-center space-x-2 ${
            actionButton?.variant === "primary"
              ? "bg-primary-500 hover:bg-primary-600"
              : "bg-primary-500 hover:bg-primary-600"
          }`}
        >
          {actionButton?.icon && (
            <FontAwesomeIcon icon={actionButton.icon} />
          )}
          <span>{actionButton?.label || "Enter Proposal Chat"}</span>
          <FontAwesomeIcon icon="arrow-right" className="text-xs" />
        </button>
      </div>
    </div>
  );
};

export default ProposalCard;
